import useFormats from '../../utilities/useFormats';

/**
 * return price with currency prefix
 * @param currency feature company currency ( not from useCompanyContext / directly useFormats() )
 * @param decimals decimals places
 * @param percentages percentages places
 * @param value input to convert
 * @returns converted value;
 */
type PriceFeatureLabelProps = {
    currency: string;
    decimals: number;
    percentages: number;
    value: number;
};

const PriceFeatureLabel = ({ currency, decimals, percentages, value }: PriceFeatureLabelProps) => {
    const { formatAmountWithCurrency } = useFormats(currency, decimals, percentages);

    return <>{formatAmountWithCurrency(value)}</>;
};

export default PriceFeatureLabel;
